"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploadError = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var react_dropzone_1 = require("react-dropzone");

var mapErrorToMessages = function mapErrorToMessages(error, messages) {
  var message;

  switch (error) {
    case react_dropzone_1.ErrorCode.FileInvalidType:
      message = messages.fileTypeError;
      break;

    case react_dropzone_1.ErrorCode.FileTooLarge:
      message = messages.maxSizeError;
      break;

    case react_dropzone_1.ErrorCode.TooManyFiles:
      message = messages.tooManyFilesError;
      break;

    case react_dropzone_1.ErrorCode.FileTooSmall:
      message = messages.minSizeError;
      break;

    default:
      message = messages.generalError;
      break;
  }

  return message;
};

var ImageUploadError = function ImageUploadError(_a) {
  var m = _a.messages,
      fileRejections = _a.fileRejections;
  var errors = fileRejections[0].errors.map(function (_a) {
    var code = _a.code;
    return code;
  });
  return react_1.default.createElement("div", null, errors.map(function (error) {
    return react_1.default.createElement(ui_flex_1.Flex, {
      alignItems: "center",
      key: error
    }, react_1.default.createElement(ui_icon_1.Icon, {
      name: "alert",
      color: "red-500",
      scale: 2,
      mr: 1
    }), react_1.default.createElement(ui_text_1.Text, {
      pattern: "caption",
      color: "red-500"
    }, mapErrorToMessages(error, m)));
  }));
};

exports.ImageUploadError = ImageUploadError;